export function contactModeBadgeLabel(mode?: string | null): string | null {
  if (!mode || mode === 'any') return null
  switch (mode) {
    case 'do_not_contact':
      return 'Не беспокоить'
    case 'written_only':
      return 'Только письменно'
    case 'voice_only':
      return 'Только звонок'
    default:
      return mode
  }
}

export function contactModeBadgeTone(mode?: string | null): 'danger' | 'warning' | 'neutral' {
  if (mode === 'do_not_contact') return 'danger'
  if (mode === 'written_only' || mode === 'voice_only') return 'warning'
  return 'neutral'
}
